__turbopack_context__.v({
  "className": "inter_1400599-module__tqvXYW__className",
});
